export const vert = /*glsl*/ `
precision mediump float;

uniform mat4 projectionMatrix;
uniform mat4 modelViewMatrix;

attribute vec3 position;

uniform float uTime;

varying float vPosLength;

#define PI 3.141592

void main() {
  float t = uTime * .0005;
  vec3 pos = position;
  pos.y = fract(pos.y - t) * 10.;
  pos.x = (fract(pos.x - t * .2) - .5) * 7.;

  vPosLength = length(pos);

  vec4 mvPosition = modelViewMatrix * vec4(pos, 1.);
  gl_PointSize = (1. / -mvPosition.z) * 200.;
  gl_Position = projectionMatrix * mvPosition;
}`;
